<template>
  <router-view />
  <CookieConsent />
  <SerialKeyDialog />
</template>

<script>
import CookieConsent from './components/CookieConsent.vue'
import SerialKeyDialog from './components/SerialKeyDialog.vue'

export default {
  name: 'App',
  components: {
    CookieConsent,
    SerialKeyDialog
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

#app {
  min-height: 100vh;
}
</style>

